import React, { PropsWithChildren, useMemo } from 'react';
import { ThemeProvider as MuiThemeProvider, Theme as MuiTheme } from '@mui/material';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { CEL_THEME, RCI_THEME } from '@rcg/ui-components';
import { Theme, ThemeProviderProps } from './ThemeContext.types';
import { BrandCode } from 'types';

function ThemeProvider({ brandCode, children }: ThemeProviderProps & PropsWithChildren) {
  const theme = useMemo<Theme>(() => {
    const brandTheme: {[key in BrandCode]: MuiTheme} = {
      [BrandCode.Celebrity]: CEL_THEME,
      [BrandCode.RoyalCaribbean]: RCI_THEME,
    };

    return {
      ...brandTheme[brandCode],
      brandCode,
    };
  }, [brandCode]);

  return (
    <MuiThemeProvider theme={theme}>
      <StyledThemeProvider theme={theme}>
        {children}
      </StyledThemeProvider>
    </MuiThemeProvider>
  );
}

export default ThemeProvider;